module.exports = __webpack_public_path__ + "img/play-video.c477b8c4.jpg";